import { styled } from '@mui/material';

export const LeaveLoadingOverlay = styled('div')({
  position: 'fixed',
  inset: 0,
  zIndex: 1400,
  background: 'rgba(9, 16, 30, 0.76)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 16,
});

export const LeaveLoadingCard = styled('div')({
  width: '100%',
  maxWidth: 360,
  background: '#ffffff',
  borderRadius: 14,
  padding: '24px 20px',
  textAlign: 'center',
  boxShadow: '0 14px 40px rgba(4, 15, 35, 0.35)',
});

export const LeaveLoadingText = styled('div')({
  marginTop: 12,
});
